import { EListType } from 'lib/entities/Case'
import React, { ReactElement } from 'react'
import CasesPage from '../Cases/CasesPage'

export default function OnHoldCases(): ReactElement {
	return <CasesPage listType={EListType.all} />
}
